import * as React from 'react'
import ReactDOM from 'react-dom'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'

const ShareFail = () => {
  const bem = Util.bemFrom('share-fail')
  const goToMainSite = () => (location.href = '/')
  return (
    <div className={bem()}>
      <div className={bem('logo')} onClick={goToMainSite} />
      <div className={bem('text')}>{Lang.msg.share.incorrectLink}</div>
    </div>
  )
}

export const showShareFail = () => {
  const cnt = document.createElement('div')
  document.body.appendChild(cnt)
  ReactDOM.render(<ShareFail />, cnt)
}
